import type { User } from '@kalos/kalos-rpc';

type CustomerLike = User | string | undefined | null;

/**
 * Extracts the full name from a customer object or string
 */
export const getCustomerName = (customer: CustomerLike): string => {
  if (typeof customer === 'string') return customer;
  if (customer?.businessname) {
    return customer.businessname;
  }
  if (customer?.firstname && customer?.lastname) {
    return `${customer.firstname} ${customer.lastname}`;
  }
  return 'Unknown Customer';
};

/**
 * Extracts initials from a customer object or string (max 2 characters)
 */
export const getCustomerInitials = (customer: CustomerLike): string => {
  if (typeof customer === 'string') {
    return customer
      .split(' ')
      .map((name) => name[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  }
  if (customer?.firstname && customer?.lastname) {
    return `${customer.firstname.charAt(0)}${customer.lastname.charAt(0)}`.toUpperCase();
  }
  return '?';
};

/**
 * Normalizes phone numbers for search comparison by removing non-digit characters
 */
export const normalizePhoneForSearch = (phone: string): string => {
  if (!phone) return '';
  return phone.replace(/\D/g, '').toLowerCase();
};
